import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createRecord} from "app/requests/admin/users";
import {withoutBlankValues} from "lib/ext/object";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import Form from "./form";

export default function AdminUsersNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [record, setRecord] = useState({
    admin: false,
    case_notifications: true,
    daily_notifications: true,
    email: "",
    first_name: "",
    last_name: ""
  });
  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (files) => {
    setBlock(false);
    createRecord({user: withoutBlankValues({...record, ...files})}).then(({message, success}) => {
      if(success) {
        navigate("/admin/users", {message, type: "success"});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  usePrompt({when: block});

  return (
    <div>
      <h1 className="text-center">Invite User</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
